import React, { useMemo } from "react";
import { usePrefersReducedMotion } from "../../hooks/use-reduced-motion";
import "./offers.css";

const BURSTS = [
  { left: "18%", top: "22%", delay: 0 },
  { left: "82%", top: "18%", delay: 0.35 },
  { left: "50%", top: "8%", delay: 0.7 },
];
const SPARKS_PER_BURST = 14;

// One short fireworks burst (about 2s, no loop) in the offer's colours.
// Renders nothing when the OS asks for reduced motion.
const OfferFireworks = ({ colors = [] }) => {
  const prefersReducedMotion = usePrefersReducedMotion();

  const sparks = useMemo(
    () =>
      BURSTS.flatMap((burst, burstIndex) =>
        Array.from({ length: SPARKS_PER_BURST }, (_, index) => {
          const angle = (index / SPARKS_PER_BURST) * Math.PI * 2;
          const distance = 46 + (index % 3) * 14;
          return {
            id: `${burstIndex}-${index}`,
            left: burst.left,
            top: burst.top,
            delay: `${burst.delay + (index % 2) * 0.05}s`,
            x: `${Math.round(Math.cos(angle) * distance)}px`,
            y: `${Math.round(Math.sin(angle) * distance)}px`,
            color: colors[(burstIndex + index) % Math.max(colors.length, 1)] || "#F5B700",
          };
        })
      ),
    [colors]
  );

  if (prefersReducedMotion) return null;

  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden="true">
      {sparks.map((spark) => (
        <span
          key={spark.id}
          className="pb-offer-firework"
          style={{
            left: spark.left,
            top: spark.top,
            backgroundColor: spark.color,
            boxShadow: `0 0 8px ${spark.color}`,
            animationDelay: spark.delay,
            "--pb-firework-x": spark.x,
            "--pb-firework-y": spark.y,
          }}
        />
      ))}
    </div>
  );
};

export default OfferFireworks;
